import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "14",
      cy: "14",
      r: "13.5",
      fill: "#c8e7f2",
      "fill-opacity": ".4",
      stroke: "#c8e7f2"
    }, null, -1),
    _createElementVNode("g", { fill: "#000" }, [
      _createElementVNode("path", { d: "M17.542 8H7.458A.46.46 0 0 0 7 8.455v1.818c0 .12.048.236.134.321s.203.133.324.133h10.084a.46.46 0 0 0 .324-.133.45.45 0 0 0 .134-.321V8.455A.453.453 0 0 0 17.542 8m-.459 1.818h-3.208V8.91h3.208zm.459 1.818H7.458a.453.453 0 0 0-.458.455v1.818a.453.453 0 0 0 .458.455h10.084a.453.453 0 0 0 .458-.455v-1.818a.453.453 0 0 0-.458-.455m-.459 1.819h-3.208v-.91h3.208zm.459 1.818H7.458a.46.46 0 0 0-.458.454v1.819a.46.46 0 0 0 .458.454h10.084a.46.46 0 0 0 .458-.454v-1.819a.45.45 0 0 0-.134-.321.46.46 0 0 0-.324-.133m-.459 1.818h-3.208v-.91h3.208z" }),
      _createElementVNode("path", {
        stroke: "#e9f5fa",
        d: "m20.152 18.567.01-.012.38.321c.53.448 1.18.99 1.374 1.141l.73.57-.225.077c.06.162.086.334.078.507v.59a.74.74 0 0 1-.736.739h-7.528a.733.733 0 0 1-.735-.74v-.602h.5a.9.9 0 0 1 .39-.747zm0 0q.11-.219.162-.462l.267-1.258c.281-.207.501-.488.637-.813l.005-.01.004-.012.123-.34a1.12 1.12 0 0 0 .035-.846l-.47.17.47-.17a1.1 1.1 0 0 0-.298-.445v-.989c0-.83-.275-1.568-.832-2.097-.555-.526-1.336-.795-2.256-.795s-1.7.269-2.255.795c-.558.53-.832 1.267-.832 2.097v.994a1.1 1.1 0 0 0-.299.444l.386.14-.386-.14a1.12 1.12 0 0 0 .036.847l.124.337.004.01.004.01c.135.325.356.606.636.813l.268 1.257v.001q.05.235.154.447l-.38.318-1.372 1.143z"
      })
    ], -1)
  ]))]))
}
export default { render: render }